import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { listTools } from '@/lib/api'
import type { Tool, ToolType } from '@/types'
import { DataTable, type Column } from '@/components/ui/DataTable'
import { Badge } from '@/components/ui/Badge'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

const FILTERS: Array<ToolType | 'todas'> = ['todas', 'acción', 'integración']

export function ToolsList() {
  const [tools, setTools] = useState<Tool[]>([])
  const [filter, setFilter] = useState<ToolType | 'todas'>('todas')
  const navigate = useNavigate()

  useEffect(() => {
    listTools().then(setTools)
  }, [])

  const filtered = filter === 'todas' ? tools : tools.filter((t) => t.tool_type === filter)

  const columns: Column<Tool>[] = [
    { header: 'Tool', cell: (t) => t.name },
    { header: 'ID', cell: (t) => t.id, mono: true },
    { header: 'Tipo', cell: (t) => <Badge>{t.tool_type}</Badge> },
    { header: 'Provider', cell: (t) => t.provider ?? '—' },
    { header: 'Vive en', cell: (t) => t.lives_on ?? '—', mono: true },
    { header: 'Auth', cell: (t) => t.auth_method ?? '—' },
  ]

  return (
    <div>
      <PendingBackendNotice endpoint="GET /tools" />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ fontSize: 20, fontWeight: 500 }}>Tools</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={{ display: 'flex', gap: 4 }}>
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                style={{
                  background: filter === f ? 'var(--surface-raised)' : 'transparent',
                  border: '1px solid var(--border-strong)',
                  color: 'var(--text-primary)',
                  borderRadius: 'var(--radius-sm)',
                  padding: '6px 12px',
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                {f}
              </button>
            ))}
          </div>
          <button onClick={() => navigate('/tools/new')} style={newButtonStyle}>+ Nuevo tool</button>
        </div>
      </div>
      <DataTable columns={columns} rows={filtered} getRowKey={(t) => t.id} onRowClick={(t) => navigate(`/tools/${t.id}`)} />
    </div>
  )
}

const newButtonStyle: React.CSSProperties = {
  background: 'var(--surface-raised)',
  border: '1px solid var(--border-strong)',
  color: 'var(--text-primary)',
  borderRadius: 'var(--radius-sm)',
  padding: '6px 12px',
  fontSize: 13,
  cursor: 'pointer',
}
